module.exports = __webpack_public_path__ + "img/home_list_1.88be5f16.png";